// The published legal texts, and the one place that says which edition is in
// force.
//
// Two very different consumers read this package. The web app publishes the
// three documents as pages and links to them from every screen; the API stamps
// the edition a new account was created under onto that account, which is the
// record that it was accepted. Both have to mean the same "version 1.0", so the
// number lives here and neither of them spells it out.

export {
  LEGAL_DOCUMENTS,
  OPERATOR_NAME,
  TERMS_EFFECTIVE_DATE,
  TERMS_VERSION,
} from "./documents.generated.ts";
export { LEGAL_LINKS, type LegalLink } from "./links.ts";
export type { LegalDocument } from "./types.ts";

import { LEGAL_DOCUMENTS } from "./documents.generated.ts";
import type { LegalDocument } from "./types.ts";

/**
 * One published document by its slug, or null when there is no such document.
 *
 * Null rather than a throw: the caller is a route that has to answer something,
 * and an address that names no document is a 404 rather than a crash.
 */
export function legalDocument(slug: string): LegalDocument | null {
  return LEGAL_DOCUMENTS.find((document) => document.slug === slug) ?? null;
}
